import { LabelAndValue } from '@/types/labelAndValue';

export const TIMEZONE_OPTIONS: readonly LabelAndValue[] = [
  // United States
  { label: 'TIMEZONE_EASTERN_STANDARD_TIME', value: 'America/New_York' },
  { label: 'TIMEZONE_CENTRAL_STANDARD_TIME', value: 'America/Chicago' },
  { label: 'TIMEZONE_MOUNTAIN_STANDARD_TIME', value: 'America/Denver' },
  { label: 'TIMEZONE_PACIFIC_STANDARD_TIME', value: 'America/Los_Angeles' },
  { label: 'TIMEZONE_ALASKA_STANDARD_TIME', value: 'America/Anchorage' },
  { label: 'TIMEZONE_HAWAII_STANDARD_TIME', value: 'Pacific/Honolulu' },

  // Europe
  { label: 'TIMEZONE_GREENWICH_MEAN_TIME', value: 'Europe/London' },
  { label: 'TIMEZONE_CENTRAL_EUROPEAN_TIME', value: 'Europe/Berlin' },
  { label: 'TIMEZONE_EASTERN_EUROPEAN_TIME', value: 'Europe/Bucharest' },
  { label: 'TIMEZONE_WESTERN_EUROPEAN_TIME', value: 'Europe/Lisbon' },
  { label: 'TIMEZONE_MOSCOW_TIME', value: 'Europe/Moscow' },

  // South America
  { label: 'TIMEZONE_ARGENTINA_TIME', value: 'America/Argentina/Buenos_Aires' },
  { label: 'TIMEZONE_BRAZIL_TIME', value: 'America/Sao_Paulo' },
  { label: 'TIMEZONE_CHILE_TIME', value: 'America/Santiago' },
  { label: 'TIMEZONE_COLOMBIA_TIME', value: 'America/Bogota' },
  { label: 'TIMEZONE_PERU_TIME', value: 'America/Lima' },
  { label: 'TIMEZONE_VENEZUELA_TIME', value: 'America/Caracas' },
  { label: 'TIMEZONE_URUGUAY_TIME', value: 'America/Montevideo' },
  { label: 'TIMEZONE_PARAGUAY_TIME', value: 'America/Asuncion' },
  { label: 'TIMEZONE_BOLIVIA_TIME', value: 'America/La_Paz' },
  { label: 'TIMEZONE_ECUADOR_TIME', value: 'America/Guayaquil' },
  { label: 'TIMEZONE_GUYANA_TIME', value: 'America/Guyana' },
  { label: 'TIMEZONE_SURINAME_TIME', value: 'America/Paramaribo' },
] as const;
